//@flow

import React from 'react';
import Rater from 'react-rater';
import { Link } from 'react-router-dom';
import capitalize from 'lodash/capitalize';
import { Card, CardBody, CardTitle, CardImg } from 'reactstrap';

import makeUrl from '../../lib/makeUrl';
import { truncateText } from '../../lib/utils';
import type { GuideData } from '../../types/cards';
import {
  LETTER_COUNT_FOR_TITLE,
  LETTER_COUNT_FOR_DESC,
} from '../../constants/lettersCount';
import { IconForCards as Icons } from '../../constants/icons';
import config from '../../config';

type Props = { cardData: GuideData, mobile?: boolean, isReviewCard?: boolean };

export default function GuideCard(props: Props) {
  const { cardData, mobile, isReviewCard } = props;
  const {
    why_mountains,
    fullname,
    starting_price,
    reviews,
    average_rating,
    id,
    media_image,
    profile_images,
    email_address,
  } = cardData || {};
  const url = makeUrl.goToProfile(fullname, id);

  const selectImage =
    profile_images && profile_images.medium
      ? `${config.RESOURCE_URL}/${profile_images.medium}`
      : media_image;
  return (
    <Card className={`placeCard ${mobile ? 'mobile' : ''}`}>
      <div className="cardImage">
        <Link to={url ? url : null}>
          <CardImg top width="100%" src={selectImage ? selectImage : ''} alt={fullname} />
        </Link>
      </div>
      <CardBody>
        <div className="cardBodyTop">
          <CardTitle>
            <i className={Icons.guide} />{' '}
            {fullname && (
              <Link to={url ? url : null}>
                {capitalize(truncateText(fullname, LETTER_COUNT_FOR_TITLE))}
              </Link>
            )}
            {isReviewCard && <div className="owner">{email_address}</div>}
          </CardTitle>
          <p>
            {why_mountains &&
              truncateText(
                why_mountains,
                isReviewCard ? LETTER_COUNT_FOR_DESC * 2 : LETTER_COUNT_FOR_DESC
              )}
          </p>
        </div>
        <div className="cardBodyBottom">
          <div className="rating">
            <div className="star">
              <Rater total={5} rating={average_rating} interactive={false} />
            </div>
            <p className="reviews">{reviews ? reviews.number_of_reviews : 0} Reviews</p>
          </div>

          {starting_price && (
            <div className="price">
              <small>Per Day</small>
              <p>USD {starting_price.amount}</p>
            </div>
          )}
        </div>
      </CardBody>
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/components/Cards/GuideCard.jsx